module.exports = __webpack_public_path__ + "static/media/icon_spiritual.8331af65.svg";